import { IStyle } from '@fluentui/react';
import { CommonStyles, IH2OTheme } from '@h2oai/ui-kit';

export interface IVersionListStyles {
  root?: IStyle;
  cardView?: IStyle;
  actions?: IStyle;
  actionButtons?: IStyle;
}

export interface IVersionListClassNames {
  root: string;
  cardView: string;
  actions?: string;
  actionButtons?: string;
}

export const versionListStylesDefault = (_theme: IH2OTheme): Partial<IVersionListStyles> => ({
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    marginTop: '16px',
  },
  cardView: {
    flex: 1,
    overflow: 'auto',
  },
  actions: {
    ...CommonStyles.flexCenterVertically,
    width: '100%',
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  },
});
